import React from "react";
import { Link } from "react-router-dom";
import ImageTile from "./ImageTile";

function ProductCard({
  item,
  accent = "from-emerald-600 to-emerald-700",
  categoryKey,
  delay = 0,
}) {
  const linkable = categoryKey && item.slug;
  const Wrapper = linkable ? Link : "article";
  const wrapperProps = linkable
    ? { to: `/products/${categoryKey}/${item.slug}` }
    : {};

  return (
    <Wrapper
      {...wrapperProps}
      className="group block glass rounded-3xl overflow-hidden glass-hover"
      style={{ willChange: "transform", contain: "layout style paint" }}
    >
      <ImageTile src={item.img} alt={item.name} emoji={item.emoji} className="aspect-[4/3]"
        imgClassName="group-hover:scale-110"
        overlayClassName="bg-gradient-to-t from-black/85 via-black/25 to-transparent">
        <div className="absolute top-3 left-3 glass-pill rounded-full px-2.5 py-1 text-[10px] uppercase tracking-widest text-stone-700">
          Export Grade
        </div>
        <div className={`absolute top-3 right-3 w-9 h-9 rounded-xl bg-gradient-to-br ${accent} flex items-center justify-center text-lg shadow-lg`}>
          {item.emoji}
        </div>
        <div className="absolute bottom-3 left-4 right-4">
          <div className="font-display text-2xl font-semibold text-white drop-shadow">{item.name}</div>
          {item.season && <div className="text-[11px] uppercase tracking-widest text-emerald-100/90 mt-0.5">{item.season}</div>}
        </div>
      </ImageTile>

      <div className="p-5">
        <p className="text-sm text-stone-600 leading-relaxed">{item.note}</p>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex gap-1.5">
            <span className="glass-pill rounded-full px-2.5 py-1 text-[10px] text-stone-600">Farm-traced</span>
            <span className="glass-pill rounded-full px-2.5 py-1 text-[10px] text-stone-600">Intl. Standard</span>
          </div>
          {linkable && (
            <span className="inline-flex items-center gap-1 text-emerald-700 text-xs opacity-70 group-hover:opacity-100 transition">
              View
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                className="w-4 h-4 translate-x-[-2px] group-hover:translate-x-0 transition-transform duration-300">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </span>
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export default React.memo(ProductCard);
